import { ROUTE_PATHS } from 'src/utils/route-paths';
import { ProductsType as ProjectsType } from 'src/constants/products';
import { useParams } from 'react-router-dom';
import {
  AGENT_ANALYTICS_ACCESS_ROLES,
  CONFIGURATION_ACCESS_ROLES,
  CONTROL_DESK_ACCESS_ROLES,
  CONVERSATIONS_ACCESS_ROLES,
  CUSTOMER_ANALYTICS_ACCESS_ROLES,
  INTEGRATION_ACCESS_ROLES,
  OVERVIEW_ACCESS_ROLES,
} from 'src/constants/roles';

// A tab in a project's menu bar.
export interface MenuBarItem {
  id: number;
  title: string;
  href: string;
  disabled?: boolean;
  // Project types (and roles) that see this tab.
  visibleFor: string[];
  roles: string[];
}

export const useMenuItems = (type: string | null): MenuBarItem[] => {
  const { id } = useParams();

  const overview: MenuBarItem = {
    id: 0,
    title: 'Overview',
    href: ROUTE_PATHS.DASHBOARD_PROJECT.replace(':id', id),
    visibleFor: [ProjectsType.agent, ProjectsType.bi, ProjectsType.customer],
    roles: OVERVIEW_ACCESS_ROLES,
  };
  const controlDesk: MenuBarItem = {
    id: 0,
    title: 'Control Desk',
    href: ROUTE_PATHS.DASHBOARD_PROJECT_CONTROL_DESK.replace(':id', id),
    visibleFor: [ProjectsType.customer],
    roles: CONTROL_DESK_ACCESS_ROLES,
  };

  const integration: MenuBarItem = {
    id: 3,
    title: 'Integrations',
    href: ROUTE_PATHS.DASHBOARD_PROJECT_INTEGRATIONS.replace(':id', id),
    disabled: !id,
    visibleFor: [ProjectsType.agent, ProjectsType.bi],
    roles: INTEGRATION_ACCESS_ROLES,
  };

  const analytics: MenuBarItem = {
    id: 1,
    title: 'Analytics',
    href: ROUTE_PATHS.DASHBOARD_PROJECT_ANALYTICS.replace(':id', id),
    disabled: !id,
    visibleFor: [ProjectsType.customer, ProjectsType.agent],
    roles: [],
  };

  const conversations: MenuBarItem = {
    id: 4,
    title: 'Conversations',
    href: ROUTE_PATHS.DASHBOARD_PROJECT_CONVERSATIONS.replace(':id', id),
    disabled: !id,
    visibleFor: [ProjectsType.customer],
    roles: CONVERSATIONS_ACCESS_ROLES,
  };

  const configuration: MenuBarItem = {
    id: 6,
    title: 'Configuration',
    href: ROUTE_PATHS.DASHBOARD_PROJECT_CONFIGURATION.replace(':id', id),
    visibleFor: [ProjectsType.customer],
    roles: CONFIGURATION_ACCESS_ROLES,
  };

  const AGENT_MENU_BAR = [
    overview,
    {
      ...analytics,
      roles: AGENT_ANALYTICS_ACCESS_ROLES,
    },
    integration,
  ];
  const CUSTOMER_MENU_BAR = [
    controlDesk,
    {
      ...analytics,
      roles: CUSTOMER_ANALYTICS_ACCESS_ROLES,
    },
    integration,
    conversations,
    configuration,
  ];
  const BI_MENU_BAR = [overview, integration];
  switch (type) {
    case ProjectsType.agent: {
      return AGENT_MENU_BAR;
    }
    case ProjectsType.customer: {
      return CUSTOMER_MENU_BAR;
    }
    case ProjectsType.bi: {
      return BI_MENU_BAR;
    }
    default: {
      return [];
    }
  }
};
